import { z } from 'zod';

/*
 * The field rules of the document and category forms, as the backend's API
 * note states them (`docs/portal-api-documents.md`, sections 3 and 4), so a
 * form refuses what the server would before sending it. These are the
 * request schema's own bounds, fixed in the API; the upload policy (types
 * and size) is a deployment setting and comes from `GET /config` instead
 * (P8, `uploadRules.ts`).
 */

export const DOCUMENT_TITLE_MAX = 100;
export const DOCUMENT_DESCRIPTION_MAX = 300;
export const CATEGORY_NAME_MAX = 60;
export const CATEGORY_DESCRIPTION_MAX = 200;

const atMost = (max: number) => `Use ${max} characters or fewer`;

/** Title, description and category of a document: the upload dialog and the drawer. */
export const documentFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'Enter a title')
    .max(DOCUMENT_TITLE_MAX, atMost(DOCUMENT_TITLE_MAX)),
  description: z.string().max(DOCUMENT_DESCRIPTION_MAX, atMost(DOCUMENT_DESCRIPTION_MAX)),
  /** A category id, or the empty string for Uncategorized. */
  categoryId: z.string().default(''),
});

export type DocumentFormInput = z.input<typeof documentFormSchema>;
export type DocumentFormValues = z.output<typeof documentFormSchema>;

/** Name and description of a category: New Category and Rename. */
export const categoryFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Enter a name')
    .max(CATEGORY_NAME_MAX, atMost(CATEGORY_NAME_MAX)),
  description: z.string().max(CATEGORY_DESCRIPTION_MAX, atMost(CATEGORY_DESCRIPTION_MAX)),
});

export type CategoryFormValues = z.output<typeof categoryFormSchema>;
